import React from "react";

const Email = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className="pointer-events-none"
		>
			<path
				d="M13.334 2.6665H2.66732C1.93398 2.6665 1.34065 3.2665 1.34065 3.99984L1.33398 11.9998C1.33398 12.7332 1.93398 13.3332 2.66732 13.3332H13.334C14.0673 13.3332 14.6673 12.7332 14.6673 11.9998V3.99984C14.6673 3.2665 14.0673 2.6665 13.334 2.6665ZM13.334 5.33317L8.00065 8.6665L2.66732 5.33317V3.99984L8.00065 7.33317L13.334 3.99984V5.33317Z"
				fill="none"
			/>
		</svg>
	);
};

export default Email;
